define((require) => {
    "use strict";

    var CompositeWidgetModel = require("shared/ui/experience/widgets/compositeWidget/CompositeWidgetModel");

    /**
     * @class {CompositeWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return CompositeWidgetModel.mixin("CompositeWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string} The self description
         */
        _getSelfDescription: function() {
            return "Group";
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/compositeWidget/CompositeWidgetModelEditorMixin.js